import Handlebars from 'handlebars';
import readableMonetize from 'lib/readable-monetize';

Handlebars.registerHelper('monetize', function (text) {
  return new Handlebars.SafeString(readableMonetize(text));
});
